export const createApplicationQuery = `
mutation CreateApplication($input: CreateApplicationInput!, $file: Upload!) {
    createApplication(input: $input, file: $file) {
      application {
        id
        jobId
        memberId
        status
      }
    }
}
`;

export const getApplicationListByMemberIdQuery = `
query GetApplicationListByMemberId($memberId: String!) {
    getApplicationListByMemberId(memberId: $memberId) {
        id
        jobId
        memberId
        status
        submittedDate
        jobInfo {
          jobTitle
          jobLocation
          totalPay
          jobRole
          jobLevel
          jobType
          duration
        }
    }
}
`;

export const withdrawApplicationQuery = `
mutation WithdrawApplication($input: WithdrawApplicationInput!) {
    withdrawApplication(input: $input) {
        status
        application {
            id
            jobId
            memberId
            status
            submittedDate
            jobInfo {
                jobTitle
                jobLocation
                totalPay
                jobRole
                jobLevel
                jobType
                duration
            }
        }
    }
}
`;

export const adminGetApplicationListQuery = `
query AdminGetApplicationList($input: AdminGetApplicationListInput!) {
    adminGetApplicationList(input: $input) {
        id
        jobId
        employeeId
        status
        submittedDate
        jobInfo {
          jobTitle
          totalPay
        }
    }
}
`;

export const AdminGetApplicationByIdQuery = `
query AdminGetApplicationById($applicationId: ID!) {
    adminGetApplicationById(applicationId: $applicationId) {
        id
        jobId
        employeeId
        status
        submittedDate
        resumeUrl
        lastUpdateBy
        lastUpdated
        jobInfo {
          jobTitle
          jobLocation
          totalPay
          jobRole
          jobLevel
          jobType
          duration
        }
    }
}
`;

export const AdminUpdateApplicationQuery = `
mutation AdminUpdateApplication($input: AdminUpdateApplicationInput!) {
    adminUpdateApplication(input: $input) {
        id
        jobId
        employeeId
        status
        submittedDate
        resumeUrl
        lastUpdateBy
        lastUpdated
        jobInfo {
          jobTitle
          jobLocation
          totalPay
          jobRole
          jobLevel
          jobType
          duration
        }
    }
}
`;
